export default {
  demo: "这是个demo哦",
  "This is the end": "到底了",
  "Load more": "加载更多",
  "Something wrong!": "出错啦！",
  Top: "置顶",
  Guest: "游客",
  Name: "姓名",
  Myself: "自己",
  Send: "发送",
  Sending: "发送中",
  Search: "搜索",
  Submit: "提交",
  Success: "成功",
  Expand: "展开",
  Fold: "收起",
  Confirm: "确认",
  Processing: "处理中",
  ok: "确定",
  all: "全部",
  nCol: "{num, plural, =1 {一} =2 {两} =3 {三} other {#}}列",
  chronological: "流程",
  Jigsaw: "拼图",
  "Long Pic": "长图",
  Poster: "海报",
  BigPicPoster:"海报",
  PrintCurrentImage: "打印",
  Download: "下载",
  Downloading: "下载中……",
  mine: "我的",
  hide: "隐藏",
  show: "显示",
  cancel: "取消",
  Loading: "加载中",
  tip: "提示",
  "long-press-to-save": "长按即可保存此图片",
  "long-press-to-save-1": "图片长按保存",
  time: "时间",
  place: "地点",
  "slide-up": "上滑翻页",
  phone: "手机号",
  validate: "验证码",
  FormError: "错误",
  "send-validate": "发送验证码",
  "Please input the right captcha": "请输入正确的验证码",
  "check-validate": "进入直播",
  "require-phone": "登录观看",
  "input-pass": "输入密码",
  "wrong-pass": "抱歉，您输入的密码有误！请核对！",
  "Please input the right mobile phone number": "请输入正确的手机号",
  "speaker-guest": "嘉宾介绍",
  "live-photo": "照片直播",
  "live-video": "视频",
  "fast-editing": "视频拍摄及快剪",
  details: "活动详情",
  agenda: "活动流程",
  organizer: "主办方",
  Introduction: "活动介绍",
  Time: "活动时间",
  Place: "活动地点",
  "Recently-visited": "最近访问",
  Go: "进入",
  Album: "我的相册",
  Like: "我的喜欢",
  "all-in-one-image": "我的拼图",
  "Click to view": "进入相册",
  "Confirm deletion": "真的不要我了？",
  "Album-OK": "真的",
  "Album-Cancel": "我再想想",
  Back: "返回",
  Loaded: "大图已加载",
  //预约部分
  "Phone-Is-required": "联系电话为必填项",
  "Name-Is-required": "联系姓名为必填项",
  "City-Is-required": "活动地点为必填项",
  "Date-Is-required": "活动日期为必填项",
  "PreOrder-Name": "请输入您的姓名",
  "Please input name": "请输入姓名",
  "PreOrder-Phone": "请输入您的手机号",
  "PreOrder-City": "请选择",
  "PreOrder-Start": "拍摄开始时间",
  "PreOrder-End": "拍摄结束时间",
  "PreOrder-Main": "即刻预约 开启无限惊喜",
  "PreOrder-Hotline": "预约电话",
  "PreOrder-Tip": "请保持手机畅通，我们将尽快与您联系",
  "Please select service type": "请选择服务类型",
  "Date not right": "结束日期不得早于开始日期",
  "Order fails": "预约失败，请致电人工客服",
  //大图
  "Click portrait": "点击头像",
  "Full image": "查看大图",
  "BigPic-Likes": "{num, plural, =0{喜欢} other {# 人喜欢}}",
  "This is the last one photo": "最后一张了",
  "This is the last one video": "最后一个了",
  //代码中的字符串
  "Not Started": "活动开始前",
  Ascending: "升序",
  Descending: "降序",
  "Order received": "预约成功",
  MAX_JIGSAW_NUM: "目前最多只能拼接{num}张图片",
  MAX_DOWNLOAD_NUM: "目前最多只能下载{num}张图片",
  MAX_SHARE_NUM: "目前最多只能分享{num}张图片",
  "min-jigsaw": "至少需要{num}张才能进行拼图",
  "min-download": "至少需要1张图片才能进行下载",
  "min-share": "至少需要1张图片才能进行分享",
  Collaging: "拼图生成中...",
  "Long-press to save": "长按图片保存",
  "Click to save": "鼠标右键保存",
  "No more photos": "已经到底了",
  "photo update": "已更新{num}张照片",
  "share-default": "即享照片直播，让每一个被分享的瞬间足够精彩",
  //我的影集相关
  "my-album": "我的影集",
  "in-album": "进入影集",
  Modify: "修改",
  Delete: "删除",
  photo: "照片",
  photos: "张",
  photos2: "张照片",
  album: "相册",
  "current album": "当前相册",
  "My friends": "我的好友",
  "Add friends": "添加好友",
  "album-tip": "小贴士",
  "album-tip-content": "为识别准确，用户上传的大头照片，",
  //注意，由于一些展示上的原因，这里要分成2行，而英文实际上用一行
  "album-tip-content2": "务必是正面清晰、无遮挡无美颜的单人照片",
  "Delete friend": "确定删除好友？",
  "Max friend number": "好友人数已达6人",
  "Max friend number2": "需删除才能添加",
  "Name placeholder": "请输入备注名称",
  "Name is required": "请输入名字",
  "+friends": "+ 好友",
  "No photos": "暂无照片",
  "No friends": "暂无关注记录",
  HideAvatar: "人脸识别",
  ShowAvatar: "显示人脸",
  "Wrong recognition": "识别有误",
  "Deleting operation is beyond retrieve": "隐藏不可还原",
  "Please upload single frontal photo": "请上传正面照片，人脸尽量充满相框",
  "after upload": "请上传正面照片，人脸尽量充满相框，上传后不能修改",
  "Changing frontal photo is not available now": "暂不支持修改正面照片",
  "Upload and agree": "上传并同意",
  "Jfoto service agreement": "服务使用协议",
  "for better service": "以便为你更好的提供服务",
  "Please read and agree to the agreement firstly": "请先阅读并同意协议",
  "no sb": "这张照片没有{name}？",
  "Deleting is beyond retrieve": "删除不可恢复",
  "photo of x": "{name}的照片",
  "detail avatar tip": "点击头像，可查看TA在当前相册的所有照片",
  Guide: "使用指南",
  "click the wrong recognition button":
    "为提高识别数量，可能会出现个别错误照片，点击下方图片，找到“识别有误”按钮即可删除",
  "How to find images quickly?": "如何快速找照片？",
  "Face Recognition": "人脸识别",
  FaceRecognitionDesc: "请上传正面清晰照片，人脸尽量充满相框",
  "Click the portrait on bottom of photo page to review all photos of him/her in this album, also to add as friend.":
    "点击照片页底部头像，可查看该人在本场活动的全部照片，还可一键添加好友。",
  "Friends' automatic recognition": "好友自动识别",
  'Click "Find" button, add friend\'s portrait to review all photos of this friend in this album. When you switch to new album, it will do automatic recognition. There is no need to reupload the portrait.':
    "点击“找人”按钮，添加好友头像，可查看当前相册中全部好友照片。切换新相册自动识别，无需每次重复上传头像。",
  "Cross albums' self-recognition": "本人跨相册识别",
  'Click "Find" button, upload your portrait, to review all your photos in your visited historical albums.':
    "点击“找人”按钮，上传自己头像，可查看访问过的全部即享相册中的自己照片。",
  "Switch portrait": "切换头像",
  "to find more of him/her": "找到更多的TA",
  Unfollow: "取消关注",
  Follow: "关注",
  "Other followings": "其他关注",

  // 下载挂件
  "Download-Pendent": "下载",
  "Download-Pendent-Bottom": "下载",
  "ChooseShare": "选图",
  "DownloadSuccess": "下载成功",

  //评论相关
  // Comment: '发表评论', // 重复了
  "All comments": "全部评论",
  "My comments": "我的评论",
  Content: "内容",
  "Please input the comment": "请输入评论内容",
  "Comment should not be longer than 140 letters": "评论不得长于140字",
  "Bullet screen": "弹幕",
  "No comments": "占个沙发，说两句吧",

  //弹幕
  DanmakuOn: "弹",
  DanmakuOff: "弹",
  "Say something": "快来说出你的感想吧",

  //视频
  "Back Home": "返回上一页",
  "Back Gallery": "返回相册",

  //号码牌
  "Enter your participate no., letters included":
    "请输入参赛号码，如有字母也请输入",

  Gotcha: "知道了",
  Border: "添加边框",
  Make: "生成海报",
  "Add border": "添加边框",
  "Scan to visit": "扫码观看照片直播",
  "Poster Building": "海报生成中",
  "Post Comment Error": "提交失败",
  Person: "人物",
  Hot: "热门",
  "One Column": "一列",
  "Two Column": "两列",
  "Four Column": "四列",
  Timeline: "时间轴",
  Waterfall: "瀑布流",
  ASC: "正序",
  DESC: "倒序",
  LiveGallery: "直播相册",
  Home: "主页",
  // 查了一下Facebook一类的，发现用的是Following
  Following: "关注的人",
  Preorder: "预约",
  My: "我的",
  MyPhoto: "我的照片",
  Photo: "照片",
  View: "浏览量",
  "Unit Piece": "/张",
  Waiting: "直播还未开始",

  // 引导页
  "People see": "人观看",
  Skip: "跳过",

  //相册相关
  // 'Switch Gallery': '切换页面',
  "Switch Gallery": "返回主页",
  Select: "请选择",

  VideoPlaybackGenerating: "直播回放生成中",
  VideoPause: "直播暂停，稍候精彩继续",
  VideoDirectEnd: "直播已结束，谢谢观看",
  VideoDirectEndStatus: "直播结束",
  // 直播状态
  // GalleryStatusRollback: '待回放',
  GalleryStatusComplete: "待回放",
  GalleryStatusRollback: "回放",
  GalleryStatusWait: "未开始",
  GalleryStatusStart: "直播",
  GalleryStatusEnd: "回顾",
  GalleryStatusAmazing: "精彩集锦",

  QrcodeNotice: "直播提醒",
  QrcodeNoticeTitle: "开启直播提醒",
  QrcodeNoticeFollow: "关注公众号",
  QrcodeNoticeTips: "直播开始前发送微信消息通知",
  QrcodeNoticeCancel: "直播提醒已取消",
  QrcodeNoticeOrdered: "已预约",

  "Redpack Opening": "领取中",

  // 我的相册
  "You can view all your photos in the history album":
    "可查看全部历史访问相册中的本人照片",
  "The photos are automatically updated": "照片随直播自动识别更新",

  // 人脸弹框
  "Turn left": "向左翻转",
  "Turn right": "向右翻转",

  // 关注列表
  "Know him/her?": "您认识TA吗？",
  "Add to friends": "添加关注",
  "Following List": "关注列表",
  "Following friends": "已关注的好友",
  "Fold friends": "展开全部关注的{num}位朋友",
  "Unfold friends": "取消展开全部关注的{num}位朋友",
  "Click on the profile below and add to friends": "点击下方头像添加关注",
  "What you can do after following": "关注后",
  'You can view all your followings by clicking "Following" in the bottom nav':
    "人物存档：可在底部导航“关注的人”中查看",
  "Face recognition scope expands to all the albums you've ever visited":
    "范围扩大：识别范围扩大至您访问过的全部相册",
  "The photos are automatically recognized by AI":
    "自动检索：直播照片更新，AI自动识别",
  "AI face recognition": "AI识图",
  "Includes all the photos you've visited":
    "识别范围包含您访问过的全部即享相册",
  "Active face recognition": "人脸主动识别",
  "You and your followings are automatically recognized":
    "本人及关注的人自动识别",

  // 我的
  "Recently visited album": "最近访问的相册",
  "History album": "历史相册",
  "My fav photo": "我喜欢的照片",
  "Added to my fav photo": "已添加到我喜欢的照片",
  "Removed from my fav photo": "已取消喜欢",
  "My jigsaw": "我的拼图",
  "My prize": "我的奖品",
  Expired: "已失效",
  Got: "已提交信息",
  "Got Time": "中奖时间",
  "Expired Time": "兑奖期限",
  LuckySubmit: "立即提交",
  "Jimage - Live photo service pioneer": "即享影像-照片直播服务开创者",
  "Click to order": "点我预约",

  //
  "The live video is not started": "直播未开始，敬请期待",
  "The live video is waiting replay": "直播回放稍后开通，敬请期待",

  // 红包 红包的翻译基本上都参考了微信官方
  "Red Packet": "红包",
  "Random Amount": "拼手气红包", //后面跟“红包”
  "Identical Amount": "普通红包", //后面跟“红包”
  Total: "总金额",
  "Amount Each": "单个金额",
  CNY: "元",
  "Current is ": "当前为",
  "Change to ": "改为",
  Quantity: "红包个数",
  "Enter number": "填写个数",
  "Best wishes": "恭喜发财，大吉大利！",
  "Prepare Red Packet": "塞钱进红包",
  "Unclaimed red packet will be refund after 24 hours":
    "未领取的红包，将于24小时后发起退款",
  "Open Red Packet": "抢红包",
  "View details": "查看领取详情",
  "Limited Red Packet1": "专属红包",
  // 太长了显示不下
  "Limited Red Packet": "专享红包，限指定人员领取",
  "You're too slow": "手太慢啦~",
  "Better luck next time": "红包擦肩而过",
  "Send succeed": "发送成功",
  "Send Forbid": "禁止发送",
  "Count down": "红包倒计时",
  "Nth send time": "{num, plural,=1{} other {第#轮} }红包发送时间",
  "Red Pack Advance Notice": "红包预告",
  "Sign up": "报名",
  "Sign up succeed": "报名成功",
  "Sign up to view": "报名观看",
  "Say words": "活动祝福",
  "Red packet's coming! ": "红包来了！",
  "Red packet status exception": "当前红包状态异常",
  "Current red packet can't be open": "当前红包不能被领取",
  "Open succeed": "领取成功",
  "'s red packet": "的红包",
  "Luckiest Draw": "手气最佳",
  "Red Packet transferred to Wallet": "已存入零钱，可直接消费",
  "Opened and total": "领取{n1}/{n2}个，共{n3}/{n4}元",
  "Red Packet total num and money": "{n}个红包共{money}元",

  "To top": "返回顶部",

  "##COMPANY": "公司名称",
  "##JOB": "职位",
  "##NAME": "姓名",
  "##PHONE": "手机号",
  "##CITY": "所在区域",
  "##EMAIL": "邮箱",
  "Signup to view": "报名观看",
  "Please input the": "请输入",
  "Please input the right": "请输入正确的",
  "Please choose": "请选择",
  CountryCode: "国际区号",
  MessageSendSuccess: "短信发送成功",
  MessageSendError: "短信发送失败",
  PhoneCodeSuccess: "",
  PhoneCodeError: "验证码错误",
  PhoneCodeErrorWhite: "验证码错误或该手机号无权限查看",

  More: "详情",
  PeopleView: "人观看",
  PeopleCount: "观看人数",

  Comment: "评论",
  Question: "提问",
  Earliest: "最早",
  Lastest: "最新",
  Recomment: "回复",
  MoreRecomment: "展开{total}条回复",
  Countdown: "倒计时",
  Day: "天",
  Hour: "时",
  Minute: "分",
  Second: "秒",
  Intro: "介绍",
  Give: "赠送",
  Given: "送出了",
  Unit: "数量",
  "Send Gift": "送礼",
  VIDEO_LIVE: "直播",
  CommentRepeat: "内容重复，请修改",
  Share: "分享",
  Copyed: "复制成功",
  SaySomething: "说点什么…",
  ClickAndLogin: "点击登录，参与互动",
  SelfCommentForbid: "您已被禁言",
  AllCommentForbid: "全体禁言",
  OnlyComment: "仅评论",
  PostPaperSuccess: "提交成功",
  PostPaperError: "提交失败",
  PostPaperError200001: "找不到提交后跳转链接",
  PostPaperError200202: "无权限进入",
  PostPaperError200208: "邀请码错误",
  PostPaperError200209: "密码错误",
  NoMorePhoto: "无新照片",
  MorePhoto: "新增{num}张照片",
  ClickRefresh: "点击刷新",
  Find: "找人",
  ZoomIn: "缩小",
  ZoomOut: "放大",
  FaceLoading: "正在识别中",
  FindPeopleNoResult: "未找到相关照片",
  FINDPEOPLE_ERROR_422: "未找到相关照片",
  FINDPEOPLE_ERROR_222202: "图片中未包含人脸，请确认是否五官清晰",
  FINDPEOPLE_ERROR_222207: "未找到相关照片",
  FINDPEOPLE_ERROR_222304: "图片尺寸过大，请上传小于2M的图片",
  DocumentEmpty: "暂无文件",
  DocumentPlayAuto: "自动",
  DocumentPlayCustom: "手动",
  DocumentDoPager: "翻页 ",
  On: "开",
  Off: "关",
  VoteJoin: "人参与投票",
  VoteEnd: "剩余时间",
  InputTheKeyword: "请输入关键字",
  Vote: "投票",
  Voted: "已投票",
  VoteWait: "距离开始还有",
  VoteHadEnd: "投票已结束",
  VoteEmpty: "暂无数据",
  ChatRoomJoin: "进入了直播间",
  ContactNow: "立即咨询",
  Wechat: "加微信",
  Phone: "打电话",
  WechatTips: "长按识别二维码，添加为微信好友",
  SeeMore: "查看详情",
  PleaseShare: "请选择分享方式",
  ShareLink: "复制链接",
  ShareQrcode: "二维码分享",

  "Not found any video": "未搜索到你的视频",
  "No hot video": "暂无热门视频",

  "Invited": "邀请了{n1}人",
  "ToInvite": "去邀请",
  "ShowMore": "查看更多",
  "Me": "我",

  // 新的个人中心
  "SettingLang":"语言",
  "SettingPhotoSort":"照片排序",
  "SettingPhotoLayout":"照片布局",
  "SystemDefault":"系统默认",
  // 底部导航
  "FindPhoto":"找照片",
  // 找照片中心
  "GalleryHistory":"相册足迹",
  "SplicePoster":"拼图海报",
  "FavPhoto":"喜欢的照片",
  "PayedPhoto":"购买的照片",
  "VisitedPerson":"看过的人",
  "UploadPhotoFind":"上传照片找人",
  "Cancel":"取消",
  "DeleteSuccess":"删除成功",
  "SetTop": "设置置顶",
  "CancelTop": "取消置顶",

  // 人物详情
  "CurrentGalleryPhoto": "当前相册识别结果",
  "HistoryGalleryPhoto": "您曾访问过的相册有相似人脸",
  "ClickShare": "分享给好友",
  "NoMatchPhoto": "没有找到符合的照片",

  // 付费
  "GalleryNeedPay": "付费",
  "GalleryPayed": "已付费",
  "PayToRemove": "去水印",
  "GalleryPayTitle":"付费相册",
  "PayRule1":"1. 购买成功后可去除水印或下载照片",
  "PayRule2":"2. 底部导航“找照片”—“购买的照片”中可查看全部购买照片",
  "PayRule3":"3. 付费后不支持退款",
  "ReadyToPay":"准备支付中",

  "Please input gallery name": "请输入相册名称",
  "LoadError": "加载失败",
  "PersonShareTip": "分享后，好友看到的人脸识别结果可能与您不完全一致，这是由于您和好友曾访问过的相册不同，AI识别范围不同造成的。对方看到的为您当前分享的相册照片及TA历史访问过的相册照片",
  "PersonCustomShare": "转发分享",
  "PersonCustomShareTitle": "请修改分享标题和描述语",
  "PersonCustomShareTitlePlaceholder": "若无修改，则使用默认标题",
  "SettingShare":"设置分享信息",
  "PleaseSettingShare":"请修改分享标题和描述语",
  "IfNotEditUseDefaultShare":"若无修改，则使用默认信息",
  "ConfirmSettingAndShare":"修改完成并分享",

  "uploadTooltip": "输入{title}上传照片",
  "NoResult": "暂无结果",
  "Failed": "失败",
  "MaxFolloweeNum":"关注人数已达上限，您可以取消关注一位，然后再尝试关注新的人物。",
};
